export default __webpack_public_path__ + "pgnv-assets/243e5efbfbcd54559cbe340b1588e138.png";